module.exports = __webpack_public_path__ + "media/images/black_history_month/chef-image1-baab6651ebf2fa1f0a70e9369a4d7c72.png";